export default __webpack_public_path__ + "static/souvik-banerjee-OMhubJCrtu0-unsplash-470358de58a920fe2e298c1fb7278b4e.jpg";